import React, { memo } from 'react';
import PropTypes from 'prop-types';
import renderIf from '@signal/utils/renderIf';
import { Wrapper, ControlsRow, ControlsColumn, FormControlWrapper, Title, Separator } from './styles';
export var ORIENTATION_ROW = 'row';
export var ORIENTATION_COLUMN = 'column';

var getControlKey = function getControlKey(control, fallbackKey) {
  var key = control.name || control.key;

  if (!key) {
    console.warn("\n      `FormControlFieldset` contains a control that does not have a name or key provided.\n      It is advised that all formControls in a fieldSet define either a name or key.\n    ");
    return fallbackKey;
  }

  return key;
};

var getControlWrapper = function getControlWrapper(orientation) {
  var Wrapper;

  switch (orientation) {
    case ORIENTATION_ROW:
      Wrapper = ControlsRow;
      break;

    case ORIENTATION_COLUMN:
      Wrapper = ControlsColumn;
      break;

    default:
      break;
  }

  return Wrapper;
};

export var FormControlFieldset = /*#__PURE__*/memo(function (props) {
  var title = props.title,
      items = props.items,
      renderFormControl = props.renderFormControl,
      hr = props.hr,
      orientation = props.orientation;
  var ControlsWrapper = getControlWrapper(orientation);
  return /*#__PURE__*/React.createElement(Wrapper, null, renderIf(title, /*#__PURE__*/React.createElement(Title, null, title)), renderIf(hr, /*#__PURE__*/React.createElement(Separator, null)), /*#__PURE__*/React.createElement(ControlsWrapper, {
    style: {
      flexDirection: orientation
    }
  }, items.map(function (control, i) {
    return /*#__PURE__*/React.createElement(FormControlWrapper, {
      key: getControlKey(control, i)
    }, renderFormControl(control));
  })));
});
export var propTypes = {
  /**
   * The title of the fieldset.
   */
  title: PropTypes.string,

  /**
   * Determines whether the hr should be shown or not.
   */
  hr: PropTypes.bool,

  /**
   * Determines the flex-direction of the contained controls.
   */
  orientation: PropTypes.oneOf([ORIENTATION_COLUMN, ORIENTATION_ROW]),

  /**
   * Items is expected to be an array of FormControls to render.
   * This propType definition might be able to be improved some
   * in the future to more clearly define this. But importing the
   * formControlPropType from FormControl would create a circular
   * dependency.
   */
  items: PropTypes.arrayOf(PropTypes.object)
};
FormControlFieldset.propTypes = propTypes;
FormControlFieldset.defaultProps = {
  hr: true,
  orientation: ORIENTATION_COLUMN
};
FormControlFieldset.displayName = 'FormControlFieldSet';
export default FormControlFieldset;